import { render, staticRenderFns } from "./promotionObjectives.vue?vue&type=template&id=2bc82556&scoped=true"
import script from "./promotionObjectives.vue?vue&type=script&lang=js"
export * from "./promotionObjectives.vue?vue&type=script&lang=js"
import style0 from "./promotionObjectives.vue?vue&type=style&index=0&id=2bc82556&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc82556",
  null
  
)

export default component.exports